import * as React from 'react';
import { Page, PageContent, PageHeader } from '../components/common/index';
import { userIsNotAuthenticatedRedir } from './authComponents';
import { Spinner } from '../components/common';
import authActions from '../auth/authActions';
interface Props {
	currentUser: UserDetails;
	actions: any;
}
class LoginPage extends React.Component<Props, {}> {

	componentDidMount() {
		setTimeout(() => {
			authActions.login()({});
		}, 1000);
	}

	render() {
		return (
			<div className="navbar-account">
				<Page>
					<PageContent>
						<PageHeader isCentered={true} className="page-header-sm" title="Redirecting you to the login pages" />
						<div className="mt-4 text-center">
							<Spinner />
							<p className="mt-3">One moment, please.</p>
						</div>
					</PageContent>
				</Page>
			</div>
		);
	}
}

export default userIsNotAuthenticatedRedir(LoginPage as any);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/LoginPage.tsx